export default "__VITE_ASSET__C5O0ri$F__"